import * as React from "react";
import { useEffect, useRef, useState } from 'react';

import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Button,
  useColorModeValue,
  Container,
  useToast,
  SimpleGrid,
  HStack,
  Link,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Center,
  Grid,
  GridItem,
  ButtonGroup,
  Spacer,
  Skeleton,
  Flex
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import markerIconPng from "../assets/images/marker-icon.png";
import { Field, Formik } from "formik";
import Masonry from "react-masonry-css";
import "../style/style.css";
import parser from "html-react-parser";
import { RangeDatepicker } from "chakra-dayzed-datepicker";
import Slider from "react-slick";
import MediaBlock from "../components/media-block";
import FavoritesBlock from "../components/favorites-block";
import ImageBlock from "../components/image-block";
import CrowdBlock from "../components/crowd-block";
import CTABlock from "../components/cta-block";
import ImagesBlock from "../components/images-block";
import ImagesGridBlock from "components/images-grid-block";
import MapBlock from "components/map-block";
import FeaturedAdBlock from "components/featured-ad-block";
import MotionBox from "components/motion-box";

interface PageData {
  id?: string | number;
  number_id?: string;
  slug?: string;
  meta_title?: string;
  meta_description?: string;
  title?: string;
  header_image_url?: string;
  content_rendered?: string;
  entry?: {
    subtitle?: string;
    featured_slides_title?: string;
  };
  fields: {
    content_blocks?: any[];
  };
}

interface SearchValues {
  dates?: string;
  categories?: number[];
  order?: string;
  title?: string;
}

interface FormValues {
  title: string;
  dates: string;
  destination: any;
  category: any;
  categories?: number[];
}

interface Variables {
  default_event_img?: string;
  [key: string]: any;
}

interface Destination {
  title?: string;
  main_img?: string;
  content?: string;
  summary?: string;
  address?: string;
  phone?: string;
  slug?: string;
  starts_display?: string;
  starts?: string;
  ends?: string;
  ends_display?: string;
  recurrence?: string;
  is_recurring?: boolean;
  recurring_event_id?: number;
  r_yearly_first?: boolean;
  r_yearly_second?: boolean;
  r_yearly_month?: string;
  r_yearly_day?: number;
  r_yearly_weekday?: string;
  r_yearly_second_month?: string;
  r_monthly_first?: boolean;
  r_monthly_second?: boolean;
  r_monthly_months?: number;
  r_monthly_day?: number;
  r_yearly_occurrence?: string;
  r_monthly_occurrence?: string;
  r_monthly_weekday?: string;
  r_weekly_weeks?: number;
  r_weekly_day?: string[];
  r_daily_days?: number;
  r_end_date?: string;
  r_end_type?: string;
  r_number_of_occurrences?: number;
  display_dates?: boolean | number;
}

const Events = () => {
  const toast = useToast();

  const [grid, setGrid] = useState(true);
  const [breakpointColumns, setBreakpointColumns] = useState({});

  const [featuredEvents, setFeaturedEvents] = useState([]);
  const [searchValues, setSearchValues] = useState<SearchValues>({});
  const [loading, setLoading] = useState(true);

  const [experiencesloading, setExperiencesLoading] = useState(false);
  const [, setExperiences] = useState([]);

  const [, setActivitiesLoading] = useState(false);
  const [, setActivities] = useState([]);


  const [, setCategoriesLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all'); // Track which category button is active

  const [selectedDestination, setSelectedDestination] = useState<Destination>({});

  const [page, setPage] = useState<PageData>({ fields: {} });
  const [variables, setVariables] = useState<Variables>({});


  const position: [number, number] = [40.9133945, -77.7782867];


  const [] = useState([]);

  // date picker
  const [selectedDates, setSelectedDates] = useState<Date[]>([new Date(), new Date()]);
  const propsConfigs = {
    inputProps: {
      borderRadius: "15px",
      size: "lg",
      fontSize: "sm"
    },
    dateNavBtnProps: {
      //variant: "outline"
    },
    dayOfMonthBtnProps: {
      defaultBtnProps: {
        borderColor: "tan.300",
        _hover: {
          background: 'blue.400',
        }
      },
      isInRangeBtnProps: {
        background: "blue.800",
        color: "tan",
      },
      selectedBtnProps: {
        background: "blue.800",
        color: "tan",
      },
      todayBtnProps: {
        borderColor: "blue.300",
        color: "blue.300",
        _hover: {
          color: 'blue.300',
        }
      }
    },
  };

  // drawers
  const { isOpen, onOpen, onClose } = useDisclosure()

  const {
    isOpen: isFilterOpen,
    onOpen: onFilterOpen,
    onClose: onFilterClose
  } = useDisclosure()

  const initialMarkers = [];
  const [markers] = useState(initialMarkers);

  const breakpointColumnsObj = {
    default: 6,
    1400: 4,
    1200: 3,
    900: 2,
    400: 1
  };

  const breakpointColumnsListObj = {
    default: 3,
    1400: 2,
    900: 1
  };

  const [events, setEvents] = useState([]);

  // Function to parse PHP serialized array
  const parsePHPSerializedArray = (serializedString: any): string[] => {
    if (!serializedString || typeof serializedString !== 'string') {
      return [];
    }

    // Check if it's a PHP serialized array
    if (serializedString.startsWith('a:')) {
      try {
        // Extract the array content using regex
        const match = serializedString.match(/a:\d+:{(.*)}/);
        if (match) {
          const content = match[1];
          const values = [];

          // Parse the serialized content to extract string values
          const stringMatches = content.match(/s:\d+:"([^"]+)"/g);
          if (stringMatches) {
            stringMatches.forEach(match => {
              const valueMatch = match.match(/s:\d+:"([^"]+)"/);
              if (valueMatch) {
                values.push(valueMatch[1]);
              }
            });
          }

          return values;
        }
      } catch (error) {
        console.error('Error parsing PHP serialized array:', error);
      }
    }

    // If it's already an array, return it
    if (Array.isArray(serializedString)) {
      return serializedString;
    }

    return [];
  };

  // Helper function to check if event is recurring (including ID-based check)
  const isRecurringEvent = (event: any): boolean => {
    const hasRecurrence = !!event.recurrence;
    const hasRecurringId = event.id === 0;
    
    return Boolean(hasRecurrence || hasRecurringId);
  };

  // Function to calculate next upcoming occurrence
  const calculateNextOccurrence = (event: any): string | null => {
    if (!event.recurrence) {
      return null;
    }

    const startDate = new Date(event.starts);

    if (!startDate || isNaN(startDate.getTime())) {
      return null;
    }
    const now = new Date();

    // If the start date is in the future, that's the next occurrence
    if (startDate > now) {
      return startDate.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    // Calculate next occurrence based on recurrence pattern
    let nextDate = new Date(startDate);

    switch (event.recurrence.toLowerCase()) {
      case 'daily':
        const dailyDays = event.r_daily_days || 1;
        // If start date is in the future, return it directly
        if (startDate > now) {
          nextDate = new Date(startDate);
        } else {
          // Calculate how many days have passed since start
          const daysDiff = Math.floor((now.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
          const cyclesPassed = Math.floor(daysDiff / dailyDays);
          const nextCycle = cyclesPassed + 1;
          nextDate = new Date(startDate.getTime() + (nextCycle * dailyDays * 24 * 60 * 60 * 1000));
        }
        break;

      case 'weekly':
        const weeklyDays = parsePHPSerializedArray(event.r_weekly_day);
        const weeklyWeeks = event.r_weekly_weeks || 1;

        // If start date is in the future, return it directly
        if (startDate > now) {
          nextDate = new Date(startDate);
        } else if (weeklyDays.length > 0) {
          // Start from the original start date and find the next occurrence after today
          let currentDate = new Date(startDate);
          let found = false;
          let attempts = 0;
          const maxAttempts = 52; // Prevent infinite loop

          while (!found && attempts < maxAttempts) {
            const dayName = currentDate.toLocaleDateString('en-US', { weekday: 'short' });
            if (weeklyDays.includes(dayName)) {
              // Check if this occurrence is after today
              if (currentDate > now) {
                nextDate = new Date(currentDate);
                found = true;
              }
            }
            if (!found) {
              // Move to the next week interval
              currentDate = new Date(currentDate.getTime() + (weeklyWeeks * 7 * 24 * 60 * 60 * 1000));
            }
            attempts++;
          }
        } else {
          // If no specific days selected, just add weeks from start date
          while (nextDate <= now) {
            nextDate.setDate(nextDate.getDate() + (weeklyWeeks * 7));
          }
        }
        break;

      case 'monthly':
        const monthlyMonths = event.r_monthly_months || 1;
        // If start date is in the future, return it directly
        if (startDate > now) {
          nextDate = new Date(startDate);
        } else {
          // Calculate how many months have passed since start
          const monthsDiff = (now.getFullYear() - startDate.getFullYear()) * 12 + (now.getMonth() - startDate.getMonth());
          const cyclesPassed = Math.floor(monthsDiff / monthlyMonths);
          const nextCycle = cyclesPassed + 1;
          nextDate = new Date(startDate.getFullYear(), startDate.getMonth() + (nextCycle * monthlyMonths), startDate.getDate());
        }
        break;

      case 'yearly':
        // If start date is in the future, return it directly
        if (startDate > now) {
          nextDate = new Date(startDate);
        } else {
          // Calculate how many years have passed since start
          const yearsDiff = now.getFullYear() - startDate.getFullYear();
          const nextYear = startDate.getFullYear() + yearsDiff + 1;
          nextDate = new Date(nextYear, startDate.getMonth(), startDate.getDate());
        }
        break;

      default:
        return null;
    }

    // Check if we've exceeded the end date
    if (event.r_end_date) {
      const endDate = new Date(event.r_end_date);
      if (nextDate > endDate) {
        return null; // No more occurrences
      }
    }

    return nextDate.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Function to format start/end times for display
  const formatTimeDisplay = (dateString: string, isRecurring: boolean = false) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    if (isRecurring) {
      // For recurring events, show just the time
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } else {
      // For non-recurring events, show the full date/time
      return date.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }
  };

  // Function to generate recurrence summary based on event data
  const generateRecurrenceSummary = (event: any) => {
    if (!event.recurrence) {
      return null;
    }

    let summary = "";

    switch (event.recurrence.toLowerCase()) {
      case 'daily':
        const dailyDays = event.r_daily_days || 1;
        summary = `This event repeats every ${dailyDays} day${dailyDays > 1 ? 's' : ''}.`;
        break;

      case 'weekly':
        const weeklyDays = parsePHPSerializedArray(event.r_weekly_day);
        const weeklyWeeks = event.r_weekly_weeks || 1;

        if (weeklyDays.length > 0) {
          const dayNames = weeklyDays.map(day => {
            const dayMap = {
              'Mon': 'Monday',
              'Tue': 'Tuesday',
              'Wed': 'Wednesday',
              'Thu': 'Thursday',
              'Fri': 'Friday',
              'Sat': 'Saturday',
              'Sun': 'Sunday'
            };
            return dayMap[day] || day;
          });

          if (dayNames.length === 1) {
            summary = `This event repeats every ${weeklyWeeks} week${weeklyWeeks > 1 ? 's' : ''} on ${dayNames[0]}.`;
          } else {
            const lastDay = dayNames.pop();
            summary = `This event repeats every ${weeklyWeeks} week${weeklyWeeks > 1 ? 's' : ''} on ${dayNames.join(', ')} and ${lastDay}.`;
          }
        } else {
          summary = `This event repeats every ${weeklyWeeks} week${weeklyWeeks > 1 ? 's' : ''}.`;
        }
        break;

      case 'monthly':
        const monthlyMonths = event.r_monthly_months || 1;
        const monthlyDay = event.r_monthly_day || 1;
        const monthlyOccurrence = event.r_monthly_occurrence;
        const monthlyDaytext = event.r_monthly_weekday;

        if (monthlyOccurrence && monthlyDaytext) {
          summary = `This event repeats every ${monthlyMonths} month${monthlyMonths > 1 ? 's' : ''} on the ${monthlyOccurrence.toLowerCase()} ${monthlyDaytext.toLowerCase()}.`;
        } else {
          summary = `This event repeats every ${monthlyMonths} month${monthlyMonths > 1 ? 's' : ''} on day ${monthlyDay}.`;
        }
        break;

      case 'yearly':
        const yearlyMonth = event.r_yearly_month;
        const yearlyDay = event.r_yearly_day || 1;
        const yearlyOccurrence = event.r_yearly_occurrence;
        const yearlyDaytext = event.r_yearly_weekday;

        if (yearlyOccurrence && yearlyDaytext) {
          summary = `This event repeats every year on the ${yearlyOccurrence.toLowerCase()} ${yearlyDaytext.toLowerCase()} of ${yearlyMonth}.`;
        } else if (yearlyMonth) {
          summary = `This event repeats every year on ${yearlyMonth} ${yearlyDay}.`;
        } else {
          summary = "This event repeats every year.";
        }
        break;

      default:
        return null;
    }

    // Add next occurrence
    const nextOccurrence = calculateNextOccurrence(event);
    if (nextOccurrence) {
      summary += ` Next occurrence: ${nextOccurrence}.`;
    }

    // Add end condition
    if (event.r_end_type === 'After' && event.r_number_of_occurrences && event.r_number_of_occurrences > 0) {
      summary += ` The event will occur ${event.r_number_of_occurrences} time${event.r_number_of_occurrences > 1 ? 's' : ''}.`;
    } else if (event.r_end_date) {
      const endDate = new Date(event.r_end_date);
      const formattedEndDate = endDate.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      summary += ` The event will end on ${formattedEndDate}.`;
    }

    return summary;
  };

  const settingsSlickEvents = React.useMemo(() => ({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: featuredEvents.length < 6 ? 4 : 5,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  }), [featuredEvents.length]);

  const LocationMarkers = () => {
    return (
      <React.Fragment>
        {markers.map(marker => <Marker
          position={marker.location}
          icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })}
          eventHandlers={{
            click: () => {
              setSelectedDestination(marker.data);
              onOpen();
            },
          }}>
        </Marker>)}
      </React.Fragment>
    );
  }

  const getEvents = (values = null) => {
    let data = [];
    axios.post(`${apiHost}/events/search`, values)
      .then(res => {
        data = res.data;
        setEvents([]);
        if (res.status == 200) {
          setEvents(data);
          setLoading(false);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const getFeaturedEvents = () => {
    let data = [];
    const values = {
      featured: true,
      //categories: [5]
    }
    axios.post(`${apiHost}/events/search`, values)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setFeaturedEvents(data);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const getCategories = () => {
    let data = [];
    axios.get(`${apiHost}/events/categories`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          setCategories(data);
          setCategoriesLoading(false);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };



  const getPage = () => {
    let data: PageData;
    axios.get(`${apiHost}/page/get/events`)
      .then(res => {
        data = res.data as PageData;
        if (res.status == 200) {
          data.number_id = data.id?.toString();
          setPage(data);
          console.log('entry-id', data.number_id);
          console.log('entry-slug', data.slug);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const getVariables = () => {
    let data = {} as Variables;
    axios.get(`${apiHost}/variables/get/global`)
      .then(res => {
        data = res.data as Variables;
        if (res.status == 200) {
          console.log(data);
          setVariables(data as Variables);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };


  const getCategory = (id) => {
    // Set active category to the selected category ID
    setActiveCategory(id.toString());
    let values: SearchValues = {};
    const after = new Date().getDate() + 180;
    const newDate = new Date().setDate(after);
    values.dates = new Date().toISOString() + '|' + new Date(newDate).toISOString();
    values.categories = [id];
    setSelectedDates([new Date(), new Date(newDate)]);
    setSearchValues(values);
    getEvents(values);

    return false;
  }

  const handleShowAllEvents = () => {
    // Set active category to 'all'
    setActiveCategory('all');
    const after = new Date().getDate() + 180;
    const newDate = new Date().setDate(after);
    // Create search values without categories
    const allEventsValues: SearchValues = {
      dates: new Date().toISOString() + '|' + new Date(newDate).toISOString()
    };
    setSelectedDates([new Date(), new Date(newDate)]);
    // Update search values and make API request
    setSearchValues(allEventsValues);
    getEvents(allEventsValues);
  }

  const handleReset = (values: FormValues = null) => {
    (document.getElementById("category") as HTMLSelectElement).value = "";
    // Reset active category to 'all'
    setActiveCategory('all');
    const after = new Date().getDate() + 180;
    const newDate = new Date().setDate(after);
    setSelectedDates([new Date(), new Date(newDate)]);

    // Create fresh search values without any previous sorting or filtering
    const resetValues: SearchValues = {
      dates: new Date().toISOString() + '|' + new Date(newDate).toISOString()
    };
    
    // Clear the searchValues state to remove any previous sorting order
    setSearchValues(resetValues);
    getEvents(resetValues);

    //let button = document.getElementsByClassName("fc-today-button")[0];
    //button.click();

    //document.getElementById("experience").value = "";
    //document.getElementById("activity").value = "";
  };

  const handleDestinationClick = async (destination) => {
    // Fetch the full event details using the same endpoint as the individual event page
    try {
      const response = await axios.get(`${apiHost}/events/get/${destination.slug}`);
      if (response.status === 200) {
        setSelectedDestination(response.data);
      } else {
        // Fallback to the original destination data if fetch fails
        setSelectedDestination(destination);
      }
    } catch (error) {
      console.error('Error fetching event details:', error);
      // Fallback to the original destination data if fetch fails
      setSelectedDestination(destination);
    }
    onOpen();
  }


  const sortClick = function (order) {
    const updatedValues = { ...searchValues, order };
    setSearchValues(updatedValues);
    getEvents(updatedValues);
  }

  const onGridList = function (breakpointColumns) {
    setBreakpointColumns(breakpointColumns)
    // Check if this is the list mode configuration by comparing with breakpointColumnsListObj
    if (JSON.stringify(breakpointColumns) === JSON.stringify(breakpointColumnsListObj)) {
      setGrid(false);
    } else {
      setGrid(true);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getPage();
    //getExperiences();
    //getActivities();
    getCategories();
    getVariables();
    //showNotification("Search for destinations notification", "info");

    const after = new Date().getDate() + 180;
    const newDate = new Date().setDate(after);
    let values: SearchValues = {};
    values.dates = new Date().toISOString() + '|' + new Date(newDate).toISOString();
    //calendarRef.current.getApi().changeView('dayGridMonth', new Date());
    setSelectedDates([new Date(), new Date(newDate)]);
    getEvents(values);
    setSearchValues(values);

    getFeaturedEvents();

    setBreakpointColumns(breakpointColumnsObj);
  }, []);



  return (
    <PageSlideFade>
      <Helmet>
        <title>{page.meta_title}</title>
        <meta name="description" content={page.meta_description} />
      </Helmet>
      <Box className="home-header-container" backgroundImage={`url(${page.header_image_url})`} backgroundPosition="center center" backgroundSize="cover" minHeight="70vh">
        <Container maxW={'5xl'}>
          <Stack
            textAlign={'center'}
            align={'center'}
            spacing={{ base: 8, md: 10 }}
            py={{ base: 20, md: 28 }}>
            <MotionBox
              w="100%"
              opacity="0"
              initial={{
                translateY: 180
              }}
              animate={{
                translateY: 0,
                opacity: 1,
                transition: {
                  delay: 0.4,
                  duration: 0.5
                }
              }}
            >
              <Heading
                as={'h1'}
                fontFamily="american"
                fontWeight={600}
                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                color="white"
                lineHeight={'100%'}
                textShadow="2px 2px 8px rgba(0,0,0,0.5)"
                mt={{ base: 20, md: 0 }}>
                {page.title} {' '}
                <Text as={'div'} fontFamily="brush" fontWeight={500}
                  fontSize={{ base: '6rem', md: '13rem' }} color="white" textShadow="2px 2px 8px rgba(0,0,0,0.5)" mt="6rem">
                  Bellefonte
                </Text>
              </Heading>
            </MotionBox>
          </Stack>

        </Container>
      </Box>
      {page.entry && page.entry.subtitle ? (
        <Box minHeight="25vh" bg="#E6DFD3">
          <Container maxW={'6xl'}>
            <Box pb={10}>
              <Text fontSize="5xl" color="white" textAlign="left">
                {parser(page.entry.subtitle)}
              </Text>
            </Box>
          </Container>
        </Box>
      ) : null}

      <Box bg="white">
        <Container maxW={'6xl'}>
          <Box className="content-block" pt={10} pb={10} textAlign="left">
            {page.content_rendered ? (
              <Text>
                {parser(page.content_rendered)}
              </Text>
            ) : null}
          </Box>
        </Container>
      </Box>

      {page.fields.content_blocks?.map((block, index) => (
        <Box key={`block-${index}`}>
          {
            {
              'anomaly.extension.favorites_block_block': <FavoritesBlock page={page} block={block} />,
              'anomaly.extension.media_block_block': <MediaBlock page={page} block={block} />,
              'anomaly.extension.image_block_block': <ImageBlock page={page} block={block} />,
              'anomaly.extension.crowd_block_block': <CrowdBlock page={page} block={block} />,
              'anomaly.extension.map_block_block': <MapBlock page={page} block={block} />,
              'anomaly.extension.cta_block_block': <CTABlock page={page} block={block} />,
              'anomaly.extension.images_block_block': <ImagesBlock page={page} block={block} />,
              'anomaly.extension.images_grid_block_block': <ImagesGridBlock page={page} block={block} />,
            }[block.extension]
          }
        </Box>
      ))}

      <Box bg="white">
        <Box>
          <div className="events-header">
            {page.entry && page.entry.featured_slides_title ? (
              <Heading
                as={'h2'}
                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                lineHeight={'110%'}
                pt={10}>
                {page.entry.featured_slides_title}
              </Heading>
            ) : null}
          </div>

          <Box p={{ base: 1, md: 20 }} pt={5} pb={{ base: 10, md: 20 }}>
            {featuredEvents && (
              <Slider {...settingsSlickEvents} className="events-slider" key={`slider-${featuredEvents.length}`}>

                {featuredEvents?.map((event, index) => (
                <div key={`${event.id}-${event.slug}-${index}`}>
                  <Box
                    w={'100%'}
                    bg="#FBEEC8"
                    boxShadow={'0 0 10px 2px #ccc'}
                    rounded={'md'}
                    _hover={{
                      bg: '#E6DFD3'
                    }}
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    overflow="hidden"
                  >
                    {(event.main_img || variables.default_event_img) && (
                      <Link onClick={() => handleDestinationClick(event)}>
                        <Image
                          src={`${event.main_img || variables.default_event_img}`}
                          w={'100%'}
                          rounded={'md'}
                          borderBottomRadius={"0"}
                        />
                      </Link>
                    )}
                    <Box flex="1" display="flex" flexDirection="column">
                      <Box position="relative" flex="1">
                        <Link onClick={() => handleDestinationClick(event)} h="100%">
                          <Box
                            display="grid"
                            gridTemplateColumns="1fr 3fr"
                            gridTemplateRows="1fr"
                            h="100%"
                          >
                            <Box bg="#D51F0C" color="white" p={2} pb={0} borderBottomStartRadius={'md'} display="flex" flexDirection="column">
                              <Text className="date-month">{event.starts_month}</Text>
                              <Text className="date-day">{event.starts_day}</Text>
                              <Box flex="1"></Box>
                            </Box>
                            <Box p={2} pb={0}>
                              <Box>
                                <Heading
                                  fontSize="md"
                                  fontFamily="Roboto"
                                  fontWeight="800"
                                  textAlign="left"
                                  lineHeight="120%"
                                  overflow="hidden"
                                  noOfLines={2}
                                  textOverflow="ellipsis"
                                  color="#D51F0C"
                                  pb={0}
                                  mb={2}
                                >
                                  {event.title}
                                </Heading>
                                <Text
                                  fontSize="1rem"
                                  textAlign="left"
                                  noOfLines={2}
                                  overflow="hidden"
                                  textOverflow="ellipsis"
                                  lineHeight="100%"
                                  pb={0}
                                  mb={2}
                                  color="#173b49"
                                >
                                  {event.summary || " "}
                                </Text>
                                <Box height="40px" display="flex" alignItems="center">
                                  {isRecurringEvent(event) && (
                                    <Box
                                      bg="#173b49"
                                      color="white"
                                      px={3}
                                      py={1}
                                      mb={2}
                                      borderRadius="full"
                                      fontSize="sm"
                                      fontWeight="medium"
                                    >
                                      Recurring Event
                                    </Box>
                                  )}

                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </div>
              ))}

              </Slider>
            )}
          </Box>

        </Box>

      </Box>

      <Box bg="white">
        <Container maxW={'8xl'}>
          <Box pb={10}>
            <Button
              onClick={() => handleShowAllEvents()}
              fontSize={{ base: "10px", md: "12px" }}
              m="4px"
              borderTopStartRadius={5}
              borderBottomStartRadius={5}
              borderTopEndRadius={5}
              borderBottomEndRadius={5}
              bg={activeCategory === 'all' ? "#fbeec8" : undefined}
              color={activeCategory === 'all' ? "black" : undefined}
              _hover={{
                bg: activeCategory === 'all' ? "#143b49" : undefined,
                color: activeCategory === 'all' ? "white" : undefined
              }}
            >
              All
            </Button>
            {categories?.map((cat, index) => (
              <Button
                onClick={() => getCategory(cat.id)}
                key={index}
                fontSize={{ base: "10px", md: "12px" }}
                m="4px"
                borderTopStartRadius={5}
                borderBottomStartRadius={5}
                borderTopEndRadius={5}
                borderBottomEndRadius={5}
                bg={activeCategory === cat.id.toString() ? "#fbeec8" : undefined}
                color={activeCategory === cat.id.toString() ? "black" : undefined}
                _hover={{
                  bg: activeCategory === cat.id.toString() ? "#143b49" : undefined,
                  color: activeCategory === cat.id.toString() ? "white" : undefined
                }}
              >
                {cat.name}
              </Button>
            ))}
          </Box>
        </Container>
      </Box>

      <Box bg="white">
        <Box>
          <SimpleGrid columns={3}>
            <Box textAlign="left">
              <Button onClick={() => onFilterOpen()} p={5} borderLeftRadius={0}>Filter</Button>
            </Box>
            <Box display={{ base: "none", md: "block" }}>
              <ButtonGroup spacing='2'>
                <Button
                  onClick={() => onGridList(breakpointColumnsObj)}
                  p={5}
                  borderTopEndRadius={0}
                  borderBottomEndRadius={0}
                  bg={grid ? "#D51F0C" : "gray.200"}
                  color={grid ? "white" : "black"}
                  _hover={{
                    bg: grid ? "#143b49" : "gray.300"
                  }}
                >
                  Grid
                </Button>
                <Button
                  onClick={() => onGridList(breakpointColumnsListObj)}
                  p={5}
                  borderTopStartRadius={0}
                  borderBottomStartRadius={0}
                  bg={!grid ? "#D51F0C" : "gray.200"}
                  color={!grid ? "white" : "black"}
                  _hover={{
                    bg: !grid ? "#143b49" : "gray.300"
                  }}
                >
                  List
                </Button>
              </ButtonGroup>

            </Box>
            <Box display="flex" flexDirection="row" alignItems="right" >
              <HStack marginLeft="auto" mb={5} mr={{ base: 0, md: 5 }}>
                <Spacer />
                <Text w="100px" textAlign="right">Sort By</Text>
                <Select
                  onChange={(e) => {
                    sortClick(e.target.value);
                  }} w={{ base: "120px", md: "200px" }}>
                  <option value="upcoming">Latest</option>
                  <option value="oldest">Oldest</option>
                </Select>
              </HStack>
            </Box>
          </SimpleGrid>
        </Box>

        {loading && (
          <Box p={5}>
            <Skeleton height="80px" />
            <Text mt="-50px" mb="50px" fontWeight="bold" textAlign="center">
              Loading Happy Valley Events ...
            </Text>
          </Box>
        )}

        <SimpleGrid columns={{ base: 1, md: 1 }} spacing={10}>
          <Box p={5}>
            {loading ? null : (
              <SimpleGrid
                columns={grid ? { base: 1, sm: 2, lg: 3, xl: 4, '2xl': 6 } : { base: 1, md: 2, lg: 3, xl: 4 }}
                spacing={5}
                className="events-grid"
              >
                {events?.map((event, index) => (
                  <Box
                    key={`${event.id}-${event.slug}-${index}`}
                    w={'100%'}
                    bg="#FBEEC8"
                    boxShadow={'0 0 10px 2px #ccc'}
                    rounded={'md'}
                    _hover={{
                      bg: '#E6DFD3'
                    }}
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    overflow="hidden"
                  >
                    {(event.main_img || variables.default_event_img) && grid && (
                      <Link onClick={() => handleDestinationClick(event)}>
                        <Image
                          src={`${event.main_img || variables.default_event_img}`}
                          w={'100%'}
                          rounded={'md'}
                          borderBottomRadius={"0"}
                        />
                      </Link>
                    )}
                    <Box flex="1" display="flex" flexDirection="column">
                      <Box position="relative" flex="1">
                        <Link onClick={() => handleDestinationClick(event)} h="100%">
                          <Box
                            display="grid"
                            gridTemplateColumns="1fr 3fr"
                            gridTemplateRows="1fr"
                            h="100%"
                          >
                            <Box bg="#D51F0C" color="white" p={2} pb={0} borderBottomStartRadius={'md'} display="flex" flexDirection="column">
                              {(event.main_img || variables.default_event_img) && !grid && (
                                <Link onClick={() => handleDestinationClick(event)}>
                                  <Image
                                    src={`${event.main_img || variables.default_event_img}`}
                                    w={'100%'}
                                    rounded={'md'}
                                    borderBottomRadius={"0"}
                                  />
                                </Link>
                              )}
                              <Text className="date-month">{event.starts_month}</Text>
                              <Text className="date-day">{event.starts_day}</Text>
                              <Box flex="1"></Box>
                            </Box>
                            <Box p={2} pb={0}>
                              <Box>
                                <Heading
                                  fontSize="md"
                                  fontFamily="Roboto"
                                  fontWeight="800"
                                  textAlign="left"
                                  lineHeight="120%"
                                  overflow="hidden"
                                  noOfLines={2}
                                  textOverflow="ellipsis"
                                  color="#D51F0C"
                                  pb={0}
                                  mb={2}
                                >
                                  {event.title}
                                </Heading>
                                <Text
                                  fontSize="1rem"
                                  textAlign="left"
                                  noOfLines={2}
                                  overflow="hidden"
                                  textOverflow="ellipsis"
                                  lineHeight="100%"
                                  pb={0}
                                  mb={2}
                                  color="#173b49"
                                >
                                  {event.summary || " "}
                                </Text>
                                <Box height="40px" display="flex" alignItems="center">
                                  {isRecurringEvent(event) && (
                                    <Box
                                      bg="#173b49"
                                      color="white"
                                      px={3}
                                      py={1}
                                      mb={2}
                                      borderRadius="full"
                                      fontSize="sm"
                                      fontWeight="medium"
                                    >
                                      Recurring Event
                                    </Box>
                                  )}

                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                ))
                }
              </SimpleGrid>
            )}

          </Box>
          <Box display="none">
            <Box sx={{ position: ['sticky', '-webkit-sticky'], top: '0px' }}>

              <MapContainer center={position} zoom={12} scrollWheelZoom={false} style={{ minHeight: L.Browser.mobile ? '50vh' : '100vh' }} tap={!L.Browser.mobile} dragging={!L.Browser.mobile}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <LocationMarkers />
              </MapContainer>

            </Box>
          </Box>
        </SimpleGrid>

        <FeaturedAdBlock page={page} block={null} />

      </Box>

      <Drawer
        isOpen={isOpen}
        size="lg"
        placement="left"
        closeOnOverlayClick={true}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            <Heading pb={0}>{selectedDestination.title}</Heading>
          </DrawerHeader>

          <DrawerBody>
            <Stack spacing="24px">
              <Center>
                {selectedDestination.main_img && (
                  <Image src={`${selectedDestination.main_img}`} borderRadius={10} />
                )}
              </Center>

              <Stack>
                <Text mb={5} color="gray.500">{selectedDestination.summary}</Text>

                {selectedDestination.display_dates !== false && selectedDestination.display_dates !== 0 && (
                  <>
                    <Text fontWeight="600">Starts: {formatTimeDisplay(selectedDestination.starts, !!selectedDestination.recurrence)}</Text>
                    {selectedDestination.ends ? (
                      <Text fontWeight="600">Ends: {formatTimeDisplay(selectedDestination.ends, !!selectedDestination.recurrence)}</Text>
                    ) : null}
                  </>
                )}
              </Stack>

              {/* Recurrence Summary */}
              {generateRecurrenceSummary(selectedDestination) && (
                <Box p={3} bg="gray.50" borderRadius="md" border="1px solid" borderColor="gray.200">
                  <Text fontSize="sm" color="gray.600" lineHeight="1.6">
                    {generateRecurrenceSummary(selectedDestination)}
                  </Text>
                </Box>
              )}

              {selectedDestination.content != null && (
                <Box className="content-block">{parser(selectedDestination.content)}</Box>
              )}
            </Stack>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px" justifyContent="flex-end">
            <Button mr={3} onClick={onClose}>
              Close
            </Button>
            {selectedDestination ? (
              <Button as={Link} href={`/events/${selectedDestination.slug}`} >More Information</Button>
            ) : null}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Drawer
        isOpen={isFilterOpen}
        size="md"
        placement="left"
        closeOnOverlayClick={true}
        onClose={onFilterClose}
      >
        <DrawerOverlay />
        <Formik
          initialValues={{ title: "", dates: "", destination: null, category: null }}
          onReset={(values) => {
            handleReset(values);
          }}
          onSubmit={(values, actions) => {
            const searchParams: SearchValues = {
              dates: '',
              categories: values.category ? [values.category] : undefined,
              title: values.title
            };

            if (selectedDates && selectedDates.length > 1) {
              searchParams.dates = selectedDates[0].toISOString() + '|' + selectedDates[1].toISOString();
            }

            // Set active category based on filter selection
            if (values.category) {
              setActiveCategory(values.category.toString());
            } else {
              setActiveCategory('all');
            }

            getEvents(searchParams);
            setSearchValues(searchParams);
            actions.setSubmitting(false);
            onFilterClose();
          }}
        >
          {({ values, handleChange, handleSubmit, handleReset, isSubmitting }) => {
            return (
              <form id="searchForm" autoComplete="off" onSubmit={handleSubmit} onReset={handleReset} onChange={handleChange} style={{ width: "100%" }}>
                <DrawerContent>
                  <DrawerCloseButton />
                  <DrawerHeader borderBottomWidth="1px">
                    <Heading pb={0}>Filter</Heading>
                  </DrawerHeader>

                  <DrawerBody>

                    <Field
                      name="dates"
                      width={"100%"}
                    >
                      {() => (
                        <FormControl>
                          <FormLabel>Dates</FormLabel>
                          <RangeDatepicker
                            name="date-input"
                            selectedDates={selectedDates}
                            onDateChange={setSelectedDates}
                            propsConfigs={propsConfigs}
                          />
                        </FormControl>
                      )}
                    </Field>

                    <Field
                      name="category"
                      width={"100%"}
                    >
                      {({ field }) => (
                        <FormControl>
                          <FormLabel mt={2}>Category</FormLabel>
                          {experiencesloading ? (
                            <Select placeholder="All"></Select>
                          ) : (
                            <Select  {...field}
                              id="category"
                              borderRadius="15px"
                              fontSize="sm"
                              type="text"
                              placeholder="All"
                              size="lg"
                              value={values.category}
                              onChange={handleChange}>
                              {categories?.map((cat, index) => (
                                <option key={index} value={cat.id}>{cat.name}</option>
                              ))
                              }
                            </Select>
                          )}
                        </FormControl>
                      )}
                    </Field>

                    <Field
                      name="title"
                      width={"100%"}
                    >
                      {({ field }) => (
                        <FormControl>
                          <FormLabel mt={2}>Event Organizer or Title</FormLabel>
                          <Input
                            {...field}
                            id="title"
                            borderRadius="15px"
                            fontSize="sm"
                            type="text"
                            placeholder='Annual'
                            size="lg"
                            value={values.title}
                            onChange={handleChange}
                          />
                        </FormControl>
                      )}
                    </Field>

                    <Box height="70vh">

                    </Box>

                  </DrawerBody>

                  <DrawerFooter borderTopWidth="1px" justifyContent="flex-end">
                    <Button mr={3} onClick={onFilterClose}>
                      Close
                    </Button>
                    <Button mr={3} type="reset">Reset</Button>
                    <Button mr={3} type="submit" isLoading={isSubmitting}>Search</Button>
                  </DrawerFooter>
                </DrawerContent>
              </form>
            );
          }}
        </Formik>
      </Drawer>

    </PageSlideFade>
  );
};

export default Events;
